<!-- Scene Editor Main UI -->
<script lang="ts">
  import SceneGraph from './SceneGraph.svelte';
  import SceneViewport from './SceneViewport.svelte';
  import Inspector from './Inspector.svelte';
  import Toolbar from './Toolbar.svelte';
</script>

<div class="scene-editor h-full w-full relative overflow-hidden">
  <!-- Toolbar -->
  <div class="toolbar-container relative z-[1000]">
    <div class="toolbar-panel relative h-16">
      <Toolbar />
    </div>
  </div>

  <!-- Main Layout -->
  <div class="flex relative" style="height: calc(100% - 64px);">
    <!-- Left Panel: Scene Graph -->
    <div
      class="scene-graph-panel w-80 bg-gray-900/90 backdrop-blur-sm border-r border-neon-purple/20 flex-shrink-0 relative z-50 pointer-events-auto"
    >
      <SceneGraph />
    </div>

    <!-- Center: Scene Viewport -->
    <div class="flex-1 relative z-10 pointer-events-none">
      <SceneViewport />
    </div>

    <!-- Right Panel: Inspector -->
    <div
      class="inspector-panel w-80 bg-gray-900/90 backdrop-blur-sm border-l border-neon-purple/20 flex-shrink-0 relative z-50 pointer-events-auto"
    >
      <Inspector />
    </div>
  </div>
</div>

<style>
  .scene-editor {
    font-family: 'Rajdhani', sans-serif;
    color: white;
  }

  .toolbar-panel {
    background: rgba(0, 0, 0, 0.8);
    backdrop-filter: blur(8px);
    border-bottom: 1px solid rgba(0, 153, 255, 0.3);
  }

  .scene-graph-panel,
  .inspector-panel {
    height: 100%;
    overflow-y: auto;
  }
</style>
